import { connectorsForWallets, Chain } from '@rainbow-me/rainbowkit';
import {
  coinbaseWallet,
  ledgerWallet,
  metaMaskWallet,
  rainbowWallet,
  walletConnectWallet,
  trustWallet
} from '@rainbow-me/rainbowkit/wallets';
import { createConfig, http } from 'wagmi';
import { mainnet, sepolia } from 'wagmi/chains';

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        metaMaskWallet,
        walletConnectWallet,
        coinbaseWallet,
      ],
    },
    {
      groupName: 'Others',
      wallets: [
        ledgerWallet,
        rainbowWallet,
        trustWallet,
      ],
    },
  ],
  {
    appName: 'VideoRoyale',
    projectId: '80515294fe6fc9b1dbb002a51241491c',
  }
);

const hardhat: Chain = {
  id: 31337,
  name: 'Hardhat',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['http://localhost:8545'] },
  },
} as const satisfies Chain;

// Select chains based on environment mode
const getChains = () => {
  const mode = import.meta.env.MODE;
  if (mode === 'production') return [mainnet] as const;
  if (mode === 'testnet') return [sepolia] as const;
  return [hardhat, sepolia, mainnet] as const;
};

const chains = getChains();

export const config = createConfig({
  chains,
  connectors,
  transports: Object.fromEntries(
    chains.map((chain) => [chain.id, http()])
  ),
});
